var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showCategories && !_vm.search)?_c('GridCategories',{staticClass:"categories-grid md:ml-0 "}):_c('GridVendors',{staticClass:"vendors-grid",attrs:{"query":_vm.query,"category":_vm.category}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }